export const legal_es_Translation = {
  terms_and_conditions: {
    title: "Términos y Condiciones",
    intro:
      "Este Acuerdo de Licencia de Usuario Final es un acuerdo válido entre Usted y la Empresa. Por favor, lea este EULA cuidadosamente. Las reglas del EULA son vinculantes para Usted. Si no está de acuerdo con las reglas del EULA, por favor, no utilice la WebApp. Si continúa utilizando la WebApp, esto significará que ha leído y entendido el EULA y acepta estar vinculado por él.",
    definitions: {
      title: "1. DEFINICIONES Y TÉRMINOS",
      description:
        "Para entender claramente las reglas del EULA, deberá familiarizarse con el significado de los términos utilizados en el EULA. En este EULA, los siguientes términos, cuando se escriben con mayúscula, tendrán los siguientes significados:",
      definitions_list: {
        account:
          "“Cuenta” – significa una cuenta personal de un usuario de los servicios de la Plataforma, proporcionada por el Administrador de la Plataforma según los Términos de Uso de la Plataforma u otro documento similar. La Cuenta se accede con una ID de Plataforma (nombre de cuenta) y una contraseña.",
        company:
          "“Empresa”, “Nosotros” – significa WEBFY, una empresa constituida en Irlanda con la siguiente dirección: Black Church. St Mary’s Place. Dublín D07 P4AX. Irlanda.",
        content:
          "“Contenido” – significa todo tipo de contenido, incluyendo, entre otros, datos, textos, imágenes, videos, sonidos, enlaces, software y otras piezas de información en cualquier forma, que se ponen a su disposición a través de la WebApp.",
        device:
          "“Dispositivo” – significa un teléfono inteligente, una tableta u otro dispositivo móvil similar que usted posea o controle legalmente exclusivamente para su uso personal no comercial.",
        eula: "“EULA” – significa este Acuerdo de Licencia de Usuario Final, que es un acuerdo vinculante entre usted y la Empresa. El EULA puede incorporar otros documentos, como la Política de Privacidad, que regulan las relaciones entre usted y nosotros con respecto al uso de la WebApp. Si un documento representa una parte del EULA, tiene una indicación clara de ello.",
        intellectual_property_rights:
          "“Derechos de Propiedad Intelectual” – significa, colectivamente, los derechos bajo cualquier patente, marca registrada, derechos de autor y leyes de secretos comerciales, y cualquier otro derecho de propiedad intelectual o propietaria reconocido en cualquier país o jurisdicción a nivel mundial, incluyendo, sin limitación, derechos morales o similares.",
        subscription:
          "“Suscripción” – significa un período durante el cual usted utiliza la WebApp en su totalidad o ciertos Contenidos adicionales por una tarifa.",
        user_generated_content:
          "“Contenido Generado por el Usuario” – significa cualquier forma de Contenido, incluyendo, entre otros, datos, textos, imágenes, videos, sonidos, enlaces, que han sido publicados por usuarios en plataformas en línea, por ejemplo, redes sociales (por ejemplo, Instagram, Facebook).",
        you: "“Usted” – significa un individuo que utiliza la WebApp.",
      },
    },
    changes_of_eula: {
      title: "2. CAMBIOS DEL EULA",
      list: {
        changes_intro:
          "Podemos introducir cambios en este EULA de vez en cuando. Deberá revisar regularmente la última versión del EULA en el enlace disponible en la página web.",
        changes_effective:
          "Si no está de acuerdo con los términos del EULA actualizado, no está permitido utilizar la WebApp a partir del día en que el EULA actualizado entre en vigor. En este caso, no debe usar la WebApp y cancelar la renovación de sus Suscripciones.",
      },
    },
    device: {
      title: "3. DISPOSITIVO",
      list: {
        use_non_owned_device:
          "Si tiene la intención de utilizar la WebApp en un Dispositivo que no le pertenece, debe tener el permiso del propietario para hacerlo. Usted será responsable de cumplir con este EULA, independientemente de si posee o no el Dispositivo.",
        access_to_non_owned_device:
          "Si no posee el Dispositivo, solo se le permite usar la WebApp a través de su Cuenta.",
        responsibility:
          "Si utiliza el Dispositivo junto con otras personas, asegúrese de que nadie más que usted pueda usar la WebApp desde su Cuenta. Todas las acciones realizadas en su Cuenta se consideran sus acciones, sin importar quién las realice. Usted es completamente responsable de todas las acciones realizadas en su Cuenta.",
        removal:
          "Si decide vender o de otro modo deshacerse del Dispositivo, deberá eliminar la WebApp del Dispositivo.",
      },
    },
    capacity_and_age: {
      title: "4. CAPACIDAD LEGAL Y EDAD",
      list: {
        over_16:
          "La WebApp está diseñada para usuarios mayores de 16 años. Si utiliza la WebApp, confirma que tiene al menos 16 años y tiene plena capacidad legal para celebrar el Acuerdo.",
        between_16_18:
          "Si tiene entre 16 y 18 años, su padre, tutor u otro representante mayor de edad debe revisar y aceptar este EULA en su nombre. Si utiliza la WebApp, confirma que su padre, tutor u otro representante mayor de edad ha aceptado los términos de este EULA y le permite utilizar la WebApp.",
      },
    },
    intellectual_property: {
      title: "5. PROPIEDAD INTELECTUAL",
      list: {
        license_grant_and_webapp_use_terms:
          "Por la presente, le concedemos una licencia no exclusiva, personal, limitada, revocable y no transferible para acceder, descargar y ejecutar la WebApp solo en su Dispositivo, siempre que acepte cumplir con todos los términos y condiciones de este EULA. Tenga en cuenta que la WebApp está licenciada, no vendida, a usted.",
        intellectual_property_rights_and_reservation_of_rights:
          "La Empresa o el licenciante de la Empresa es el único titular de los Derechos de Propiedad Intelectual con respecto a la WebApp. La Empresa mantiene todos los derechos, títulos e intereses en y sobre la WebApp y se reserva todos los derechos no expresamente concedidos a usted en este EULA.",
        restrictions_on_transferring_rights_to_webapp:
          "No puede vender, revender, distribuir, redistribuir, alquilar, arrendar, sublicenciar, ceder, copiar ni de ninguna otra manera transferir o conceder derechos sobre la WebApp a ningún tercero.",
        restrictions_on_network_distribution_and_access:
          "No puede distribuir ni poner la WebApp a disposición a través de ninguna red donde pueda ser descargada o utilizada por múltiples usuarios al mismo tiempo, excepto cuando esté expresamente autorizado por nosotros.",
        prohibitions_on_interfering_with_webapp_functionality:
          "No puede utilizar ningún dispositivo o proceso automático o manual para interferir con el funcionamiento adecuado de la WebApp. Sin embargo, puede usar cualquier tipo de dispositivo o proceso para eliminar la WebApp de su Dispositivo.",
        prohibitions_on_decompiling_and_reverse_engineering:
          "No puede descompilar, desensamblar, realizar ingeniería inversa ni crear trabajos derivados de la WebApp o de cualquier parte de la misma. Todas las modificaciones o mejoras de la WebApp siguen siendo propiedad exclusiva de la Empresa.",
        prohibitions_on_unlawful_use_and_malicious_activity:
          "No puede usar la WebApp de manera ilegal, para fines ilegales, o de manera inconsistente con este EULA o actuar fraudulentamente o maliciosamente, por ejemplo, hackeando o insertando código malicioso, como virus, o datos dañinos, en la WebApp.",
      },
    },
    subscription_and_trial_period: {
      title: "6. SUSCRIPCIÓN Y PERÍODO DE PRUEBA",
      list: {
        subscription_basis_and_fee_variation:
          "Esta WebApp en su totalidad o su parte (contenido adicional) se proporciona sobre una base de suscripción paga. La tarifa puede variar dependiendo de la duración del Período de Suscripción.",
        automatic_renewal_and_account_charge:
          "La Suscripción se renovará automáticamente por el mismo período al final de la Suscripción al costo del paquete elegido. Su Cuenta será cargada por la Suscripción renovada dentro de las 24 horas previas al final de la Suscripción actual.",
        cancellation_of_subscription_renewal:
          "Puede cancelar la renovación de la Suscripción al menos 24 horas antes del final de la Suscripción: en este caso, la WebApp en su totalidad o su contenido adicional estará disponible para usted hasta el final de la Suscripción. Para cancelar la renovación automática de la Suscripción, cambie la configuración de suscripción de su Cuenta. Después del final de la Suscripción, la WebApp en su totalidad o su contenido adicional solo estará disponible si se compra una nueva Suscripción.",
        manual_cancellation_required:
          "Su suscripción no se detendrá automáticamente. Debe cancelar la renovación automática de su suscripción para evitar el cargo de la nueva Suscripción.",
        free_trial_period_and_auto_conversion:
          "La WebApp ofrece un período de prueba gratuito de 7 días. Puede usar la WebApp o su contenido adicional sin costo durante este período. Tenga en cuenta que al final del período de prueba se convertirá automáticamente en una Suscripción paga por el período más corto disponible y su Cuenta será cargada con el costo de dicha Suscripción, a menos que cancele la Suscripción a través de la configuración de suscripción de su Cuenta al menos 24 horas antes del final del período de prueba gratuito.",
      },
    },
    fees_and_purchase_terms: {
      title: "7. TARIFAS Y TÉRMINOS DE COMPRA",
      list: {
        subscription_costs_availability:
          "Los costos de todas las Suscripciones están disponibles en la página web.",
        payment_processing_by_platform_administrator:
          "Cuando compre una Suscripción, el Administrador de la Plataforma cargará su Cuenta y recogerá el dinero en nuestro nombre. El pago se procesa mediante un sistema de procesamiento de pagos implementado por el Administrador de la Plataforma.",
        no_access_to_payment_information:
          "Tenga en cuenta que nosotros no procesamos su pago ni tenemos acceso a su información de pago, como, entre otros, los datos de su tarjeta bancaria, su nombre u otra información relacionada.",
        questions_on_payment_processing:
          "Si tiene alguna pregunta respecto al procesamiento de pagos, por favor, envíe su consulta al servicio de soporte de usuarios del Administrador de la Plataforma.",
        account_charge_timing:
          "Su Cuenta será cargada con el costo de la nueva Suscripción dentro de las 24 horas previas al final de la Suscripción actual. Si cancela la renovación automática dentro de las últimas 24 horas de la Suscripción, dicha cancelación entrará en efecto al final de la nueva Suscripción.",
        no_refunds_and_immediate_content_access:
          "Tenga en cuenta que no hacemos reembolsos. El contenido digital está disponible para usted inmediatamente después de que se cargue la tarifa de Suscripción en su Cuenta.",
      },
    },
    user_generated_content: {
      title: "8. CONTENIDO GENERADO POR EL USUARIO",
      list: {
        exposure_to_objectionable_content:
          "Dado que puede acceder a publicaciones de otros usuarios de Instagram, puede estar expuesto a Contenido generado por el usuario potencialmente objetable. Tenga en cuenta que la Empresa no controla ni revisa previamente ningún Contenido generado por el usuario publicado en ninguna red social.",
        modifications_and_censorship:
          "Cualquier tipo de modificación o censura por parte de la Empresa con respecto al Contenido generado por el usuario puede ser considerada una violación de los derechos humanos o de derechos de autor y puede potencialmente engañarlo.",
        handling_objectionable_content:
          "Si ha estado expuesto a algún tipo de contenido objetable, puede utilizar la funcionalidad de la red social respectiva para rastrear y eliminar el Contenido generado por el usuario objetable.",
        company_disclaimer:
          "En ninguna circunstancia la Empresa será responsable de ningún Contenido generado por el usuario.",
      },
    },
    disclaimer: {
      title: "9. DESCARGO DE RESPONSABILIDAD",
      list: {
        general_disclaimer_of_warranties:
          "En la medida máxima permitida por la ley aplicable, nosotros y nuestros afiliados, oficiales, empleados, agentes, socios y licenciantes renunciamos expresamente a todas las garantías de cualquier tipo, expresas o implícitas, en cuanto a la exactitud, adecuación o integridad de la información contenida en nuestra WebApp o creada por los servicios.",
        content_provided_as_is:
          "El Contenido en nuestra WebApp se proporciona a usted en una base de ‘tal cual está’, sin garantías en cuanto a comerciabilidad o idoneidad para un propósito o uso particular. No garantizamos que usted obtendrá el resultado anticipado del uso de la WebApp.",
        no_warranty_on_specifics: {
          title: "No hacemos ninguna garantía de que:",
          a: "la WebApp cumpla con sus requisitos;",
          b: "la WebApp esté libre de errores, segura o ininterrumpida;",
          c: "se corregirán los errores de funcionalidad de la WebApp;",
          d: "la calidad de la WebApp cumplirá con sus expectativas.",
        },
        limitation_of_liability:
          "No asumimos ninguna responsabilidad por errores u omisiones. No somos responsables de ningún daño, ya sea directo o indirecto, especial o consecuente, sufrido por usted o por cualquier otra persona por el uso de la WebApp, incluso si se le ha advertido de la posibilidad de dichos daños. Ningún consejo o información, ya sea oral o escrita, obtenida por usted de nosotros o de nuestra WebApp creará ninguna garantía no expresamente indicada en el EULA. En ningún caso nuestra responsabilidad o la de cualquiera de nuestros afiliados, de acuerdo con cualquier causa de acción, ya sea en contrato, agravio o de otro tipo, excederá la tarifa pagada por usted para acceder a la WebApp. Además, no asumimos ninguna responsabilidad por retrasos o fallos debido a circunstancias fuera de nuestro control.",
      },
    },
    transfer_of_rights: {
      title: "10. TRANSFERENCIA DE DERECHOS",
      list: {
        transfer_by_company:
          "Podemos transferir nuestros derechos y obligaciones bajo este EULA a cualquier otra organización o individuo sin su consentimiento. Siempre le informaremos por escrito si esto ocurre y nos aseguraremos de que la transferencia no afecte sus derechos bajo el EULA.",
        transfer_by_user:
          "Solo puede transferir sus derechos o sus obligaciones bajo este EULA a otra persona si nosotros estamos de acuerdo por escrito.",
      },
    },
    termination_of_rights: {
      title: "11. TERMINACIÓN DE DERECHOS",
      list: {
        termination_for_breach:
          "Podemos terminar sus derechos para usar la WebApp en cualquier momento contactándolo si ha violado las reglas de este EULA de manera grave. Si lo que ha hecho se puede corregir, le daremos una oportunidad razonable para hacerlo.",
        actions_upon_termination: {
          title: "Si terminamos sus derechos para usar la WebApp:",
          a: "Debe detener todas las actividades autorizadas por este EULA, incluido su uso de la WebApp.",
          b: "Debe eliminar o remover la WebApp de todos los Dispositivos y destruir inmediatamente todas las copias de la WebApp que tenga y confirmar a nosotros que ha hecho esto.",
        },
      },
    },
    miscellaneous: {
      title: "12. DIVERSOS",
      list: {
        separation_of_paragraphs:
          "Cada uno de los párrafos de este EULA opera de manera independiente. Si algún tribunal o autoridad competente decide que alguno de ellos es ilegal, los párrafos restantes seguirán en pleno vigor y efecto.",
        delay_in_enforcement:
          "Incluso si retrasamos la aplicación de este EULA, aún podemos aplicarlo más adelante. Si no insistimos de inmediato en que haga algo que se le requiere bajo los términos de este EULA, o si retrasamos la toma de medidas contra usted en relación con su incumplimiento del EULA, eso no significará que no tenga que hacer esas cosas y no impedirá que tomemos medidas contra usted en una fecha posterior.",
        governing_law:
          "Este EULA se regirá e interpretará de acuerdo con las leyes de Dublín, Irlanda, sin tener en cuenta sus disposiciones sobre conflictos de leyes.",
        dispute_resolution:
          "Si surge alguna disputa, controversia o diferencia entre usted y la Empresa, se resolverá de manera amistosa mediante negociaciones. En caso de que dicha disputa, controversia o diferencia no pueda resolverse amistosamente mediante negociaciones dentro de un período de treinta (30) días, se resolverá por la Asociación de Arbitraje de Irlanda de acuerdo con sus Procedimientos Internacionales Acelerados.",
        number_of_arbitrators: "El número de árbitros será uno.",
        place_of_arbitrators: "El lugar de arbitraje será Dublín, Irlanda.",
        language_of_arbitrators:
          "El arbitraje se llevará a cabo y el laudo se dictará en inglés.",
        expense:
          "Cada parte (es decir, usted y la Empresa) asumirá sus propios gastos, pero las partes compartirán por igual los gastos del tribunal de arbitraje.",
        support:
          "Soporte. Si desea obtener más información sobre la WebApp o tiene problemas para usarla, por favor, contáctenos en <tag>support@freelanz.app</tag>",
      },
    },
  },
  privacy_policy: {
    title: "Privacidad y Política",
    commitment_title: "Nuestro Compromiso con su Privacidad",
    commitment_text:
      "Respetamos y protegemos la privacidad de los usuarios de nuestra WebApp. Esta Política de Privacidad explica cómo recopilamos y utilizamos su información y es parte de nuestros Términos de Uso cuando usa nuestra WebApp. Al utilizar nuestra WebApp y el servicio proporcionado a través de la WebApp (“Servicio”), usted acepta nuestra Política de Privacidad. Si no está de acuerdo, por favor, no use nuestra WebApp.",
    info_collection_title: "¿Qué información recopilamos?",
    info_collection_text:
      "Si realiza compras o adquiere una suscripción, nuestros proveedores de servicios de facturación de terceros recopilarán información como su nombre completo, número de tarjeta de crédito y dirección de facturación. Si nos envía un correo electrónico, podemos usar su dirección de correo electrónico para responderle. Información enviada por su dispositivo móvil. Recopilamos cierta información que su dispositivo móvil envía cuando usa nuestra WebApp, como un identificador de dispositivo, configuraciones de usuario y el sistema operativo de su dispositivo, así como información sobre el uso de nuestros Servicios. Información de ubicación. Cuando utiliza nuestra WebApp, podemos recopilar y almacenar información sobre su ubicación convirtiendo su dirección IP en una geolocalización aproximada o accediendo a las coordenadas GPS de su dispositivo móvil o ubicación aproximada si habilita los servicios de ubicación en su dispositivo. Podemos usar la información de ubicación para mejorar y personalizar nuestros Servicios para usted. Si no desea que recopilemos información de ubicación, puede deshabilitar esa función en su dispositivo móvil.",
    info_storage_title: "¿Dónde almacenamos su información?",
    info_storage_text:
      "Su información puede almacenarse en nuestros propios servidores o en servidores propiedad de proveedores de almacenamiento en la nube de terceros. Los proveedores de almacenamiento de terceros no pueden usar su información excepto como se establece en esta Política de Privacidad.",
    info_usage_title: "¿Cómo usamos su información?",
    info_usage_text:
      "La información que recopilamos de usted puede usarse para:",
    info_storage_duration_title: "¿Cuánto tiempo almacenamos su información?",
    info_storage_duration_text:
      "Pretendemos almacenar parte de su información indefinidamente. ¿Qué pasa con los enlaces a otros sitios web? Podemos proporcionar enlaces o compatibilidad con otros sitios web. Sin embargo, no somos responsables de las prácticas de privacidad empleadas por esos sitios web ni de la información o el contenido que contienen.",
    info_protection_title: "¿Cómo protegemos su información?",
    info_protection_text:
      "Utilizamos procedimientos físicos, electrónicos y de otro tipo adecuados para salvaguardar y proteger la información que recopilamos. Sin embargo, tenga en cuenta que Internet es un entorno inherentemente inseguro y que los piratas informáticos están trabajando constantemente para derrotar las medidas de seguridad. Por lo tanto, no podemos garantizar que su información no será accedida, divulgada, alterada o destruida, y usted acepta este riesgo.",
    user_protection_title: "¿Cómo puede proteger su información?",
    user_protection_text:
      "Le instamos a que tome medidas para mantener segura su información personal no compartiéndola con otros ni publicándola en línea.",
    disclosure_title: "¿Revelamos alguna información a terceros?",
    disclosure_text:
      "No recopilamos, vendemos, comercializamos ni transferimos de otro modo a terceros su Información Personalmente Identificable (PII) con fines comerciales o de marketing, excepto como se indica aquí. La información personal (y no personal) recopilada a través del Sitio puede compartirse con empresas y organizaciones que realicen servicios en nuestro nombre (por ejemplo, empresas que brinden servicios de gestión de datos u otros servicios de apoyo, como almacenamiento de datos y servicios de alojamiento web). Podemos compartir su información personal (y no personal) con terceros para ofrecerle publicidad relevante y comercializar nuestros productos, pero no venderemos su información personal. Información revelada en relación con transacciones comerciales. Si somos adquiridos por un tercero como resultado de una transacción como una fusión, adquisición o venta de activos, o si nuestros activos son adquiridos por un tercero en caso de que cerremos o entremos en quiebra, algunos o todos nuestros activos, incluida su PII, pueden divulgarse o transferirse a un adquirente tercero en relación con la transacción. Información divulgada para nuestra protección y la protección de otros. Cooperamos con funcionarios gubernamentales y de las fuerzas del orden o con terceros privados para hacer cumplir y cumplir con la ley. Podemos divulgar cualquier información sobre usted a funcionarios gubernamentales o de las fuerzas del orden o a terceros privados, según lo consideremos a nuestra entera discreción, como necesario o apropiado: (i) para responder a reclamaciones, procesos legales (incluidas citaciones); (ii) para proteger nuestra propiedad, derechos y seguridad, y la propiedad, derechos y seguridad de un tercero o del público en general; y (iii) para detener cualquier actividad que consideremos ilegal, poco ética o legalmente susceptible de acción.",
    not_for_children_title: "No está destinado a niños",
    not_for_children_text:
      "Nuestra WebApp y el Servicio no están destinados a niños menores de 16 años. No recopilamos de manera consciente o específica información de o sobre niños menores de 16 años.",
    policy_changes_title: "Cambios en nuestra Política de Privacidad",
    policy_changes_text:
      "Si decidimos cambiar nuestra Política de Privacidad, publicaremos esos cambios en esta página. También podemos, pero no estamos obligados a, enviarle un aviso por correo electrónico. Le alentamos a que revise esta política de privacidad con frecuencia para estar informado de cómo estamos protegiendo su información.",
    contact_title: "Contáctenos",
    contact_text:
      "Si tiene preguntas sobre nuestra Política de Privacidad, contáctenos en <tag>support@freelanz.app</tag>",
  },
};

export const screens_es_Translation = {
  common_text: {
    male: "Masculino",
    female: "Femenino",
    terms_and_conditions: "Términos y Condiciones",
    privacy_policy: "Política de Privacidad",
    copy_right: "Copyright ® 2024. Todos los Derechos Reservados.",
    continue: "Continuar",
    login_text: "acceso",
  },
  landing_page: {
    title: "Cursos personalizados de IA",
    personalized_freelance_plan: "Crea tu camino hacia la libertad",
    start_freelance_business:
      "Inicia un Negocio Freelance: <tag/>Sé tu propio jefe",
    launch_successful_business: "Lanza tu Negocio Freelance Exitoso Hoy",
    select_text: "Selecciona tu género:",
  },
  career_plan: {
    title: "Plan de libertad profesional según tu edad",
    age_18_24: "18-24",
    age_25_34: "25-34",
    age_35_44: "35-44",
    age_45_plus: "45+",
  },
  community: {
    title: "$36,000",
    sub_title: "podría ser donde comience tu aventura freelance",
  },
  goal_selection: {
    question: "¿Cuál es tu objetivo?",
    priority: "Selecciona tu primera prioridad",
    grow_wealth: "Incrementar riqueza",
    be_boss: "Ser mi propio jefe",
    travel_more: "Viajar más",
    other: "Otro",
  },
  income_source: {
    question: "¿Cuál es tu fuente de ingreso actual?",
    job: "Trabajo de 9 a 5",
    freelance: "Freelance",
    other: "Otro",
  },
  income_level: {
    question: "Elige tu nivel de ingreso actual",
    low: "Bajo",
    medium: "Medio",
    high: "Alto",
  },
  financial_situation: {
    question: "¿Cómo describirías tu situación financiera?",
    struggling: "Estoy luchando para cumplir con mis metas financieras",
    stability: "Me gustaría tener más estabilidad",
    unsure: "No estoy seguro",
    comfortable: "Estoy cómodo",
    range_30_50k: "$30,000-$50,000",
    range_50_100k: "$50,000-$100,000",
    range_above_100k: "Más de $100,000",
  },
  remote_work: {
    question: "¿Valoras la flexibilidad del trabajo remoto en tu carrera?",
    yes: "Sí",
    maybe: "Quizás",
    no: "No",
  },
  work_family_balance: {
    question: "¿Te cuesta <tag/> equilibrar el trabajo y el tiempo en familia?",
    absolutely: "Absolutamente",
    somewhat: "Algo",
    work_life_balance:
      "Tengo un equilibrio entre el trabajo y la vida personal",
    prefer_not_to_say: "Prefiero no decirlo",
  },
  work_situation: {
    question: "¿Qué tipo de situación laboral aspiras a tener?",
    remote_balance: "Equilibrio remoto",
    stable_routine: "Rutina estable",
    exploring_options: "Estoy explorando opciones",
  },
  travel_while_working: {
    question: "¿Te gustaría poder viajar mientras trabajas?",
    dream: "Es un sueño",
    traveling: "Estoy viajando",
    sometimes: "A veces",
    not_priority: "No es una prioridad",
  },
  content_writing_knowledge: {
    question: "Califica tu conocimiento en redacción de contenido",
    upwork_info:
      "Según Upwork, un redactor freelance gana alrededor de $42,000 anuales",
    need_more_info: "Necesito más información",
    know_everything: "Sé todo",
  },
  ai_content_creation: {
    question:
      "¿Sabías que las herramientas de IA pueden hacer que la creación de contenido sea aún más fácil?",
    no_news: "No, esto es nuevo para mí",
    curious: "Tengo curiosidad",
    heard_of_it: "Sí, lo he escuchado",
  },
  digital_marketing_knowledge: {
    question: "Califica tu conocimiento en marketing digital",
    upwork_info:
      "Según Upwork, un especialista en marketing digital gana alrededor de $100,000 anuales.",
    need_more_info: "Necesito más información",
    know_everything: "Sé todo",
  },
  promote_business_ability: {
    question: "Califica tu habilidad para promocionar negocios",
    upwork_info:
      "El 70% de los freelancers encuentran su trabajo en línea, y tú también puedes.",
    need_more_info: "Necesito más información",
    know_everything: "Sé todo",
  },
  ai_promotion_help: {
    question:
      "¿Sabías que las herramientas de IA pueden ayudarte con la promoción?",
    no_news: "No, esto es nuevo para mí",
    curious: "Tengo curiosidad",
    heard_of_it: "Sí, lo he escuchado",
  },
  job_interests: {
    question: "Elige los trabajos que podrían interesarte",
    digital_marketing: "Marketing Digital",
    smm: "SMM",
    affiliate_marketing: "Marketing de Afiliados",
    dropshipping: "Dropshipping",
    content_writing: "Redacción de Contenido",
    copywriting: "Copywriting",
    translation: "Traducción",
    graphic_design: "Diseño Gráfico",
    blogging: "Blogging",
    illustration: "Ilustración",
    continue: "Continuar",
  },
  freelancing_readiness: {
    question: "Califica tu preparación para comenzar a trabajar como freelance",
    need_more_info: "Necesito más información",
    know_everything: "Sé todo",
  },
  freelance_platforms: {
    question: "Plataformas de freelance que has oído mencionar",
    freelancer: "Freelancer",
    linkedin: "LinkedIn",
    fiverr: "Fiverr",
    guru: "Guru",
    toptal: "Toptal",
    upwork: "Upwork",
    designhill: "Designhill",
    flexjobs: "Flexjobs",
    behance: "Behance",
    wwr: "WWR",
  },
  summary_screen: {
    title: "Resumen de tu <line/> <tag>perfil freelance</tag>",
    readiness_score: "Puntuación de Preparación",
    result_perfect: "Resultado: Perfecto",
    required_score: "Requerido - 75",
    impressive_score:
      "Puntuación impresionante para tener éxito en el freelancing",
    description:
      "Los freelancers disfrutan de una mayor flexibilidad y potencial de ganancias, con un 61% de ellos ganando más que en trabajos tradicionales. Tú también puedes beneficiarte del freelance.",
    mindset: "MENTALIDAD",
    entrepreneur: "Emprendedor",
    motivation: "MOTIVACIÓN",
    high: "Alta",
    time_for_freelancing: "TIEMPO",
    for_freelancing: "Para freelancing",
    knowledge: "CONOCIMIENTO",
    beginner: "Principiante",
  },
  special_achievement: {
    question: "¿Hay algo especial que desees lograr?",
    options: {
      buy_house: "Comprar una casa",
      perfect_wedding: "Una boda perfecta",
      vacation: "Vacaciones",
      buy_car: "Comprar un auto nuevo",
      retirement: "Jubilación sin preocupaciones",
    },
    continue: "Continuar",
  },
  time_to_goal: {
    question:
      "¿Cuánto tiempo estás dispuesto a dedicar para alcanzar tu objetivo?",
    options: {
      five_min: "5 min/día",
      ten_min: "10 min/día",
      fifteen_min: "15 min/día",
      twenty_min: "20 min/día",
    },
  },
  personal_plan: {
    title: "Tu plan personal para la libertad profesional",
    based_on_answers:
      "Según tus respuestas, esperamos que adquieras las habilidades freelance necesarias de",
    confident_freelancer_by: "Freelancer seguro para {{month}}, {{year}}",
    confident: "Seguro",
    freelancer: "Freelancer",
    beginner: "Principiante",
    continue: "Continuar",
  },
  designing_plan: {
    title: "Estamos diseñando tu plan de libertad profesional…",
    people_chosen: "Más de 70,000 personas",
    chosen_freelanz_app: "han elegido Freelanz.app",
    exploring_financial_freedom: "Explorando la Libertad Financiera",
    essential_guide: "Guía esencial",
    great_discovery: "Gran descubrimiento",
  },
  testimonials: {
    sean: {
      name: "Sean",
      text: "FreeLanz potencia la libertad financiera a través del trabajo freelance. Su interfaz simplificada y las diversas oportunidades lo convierten en un recurso valioso para nuevos freelancers como yo.",
    },
    angel: {
      name: "Angel",
      text: "Estoy emocionado con mi viaje de aprendizaje con FreeLanz, donde se exploran una amplia gama de temas freelance en sus cursos. La redacción es mi favorita.",
    },
    trisha: {
      name: "Trisha",
      text: "FreeLanz me inspiró a buscar conocimientos en tecnología e IA, empujándome a superar mi ansiedad y apuntar a grandes alturas.",
    },
  },
  email_signup: {
    title:
      "Ingresa tu correo electrónico para obtener tu plan personal de <tag>Libertad Profesional</tag>!",
    privacy_note:
      "Respetamos tu privacidad. Tu correo electrónico puede hacer que la experiencia publicitaria sea más relevante <tag> Política de Privacidad </tag>.",
    email_label: "Tu Correo Electrónico",
    email_placeholder: "Ingresa una dirección de correo válida",
    success_message: "¡Bien hecho!",
  },
  login: {
    title: "Iniciar sesión",
    description:
      "Ingresa tu dirección de correo electrónico registrada para acceder a la aplicación",
    email_label: "Tu correo electrónico",
    email_placeholder: "Ingresa una dirección de correo válida",
    login_button: "Iniciar sesión",
    no_account: "¿No tienes una cuenta? <tag>Regístrate</tag>",
  },
  career_plan_ready: {
    title: "¡Tu Plan de Libertad Profesional de 4 semanas está listo!",
    readiness_level: "Tu nivel de preparación",
    after_4_weeks: "Después de 4 semanas",
    now: "Ahora",
    week_labels: {
      week_1: "Semana 1",
      week_2: "Semana 2",
      week_3: "Semana 3",
      week_4: "Semana 4",
    },
  },
  otp: {
    title: "Ingresa el OTP",
    message:
      "Se ha enviado una contraseña de un solo uso a tu <tag/> Correo Electrónico: {{email}}",
    submit_button: "Enviar",
    resend_otp: "Reenviar OTP",
  },
  payment: {
    email_placeholder: "Introduce una dirección de correo electrónico válida",
    email: "correo electrónico",
    expires_on: "EXPIRA EL",
    process_card: "Tarjeta de proceso",
    card_number: "NÚMERO DE TARJETA",
    discount_expires: "Descuento expira en",
    try_now: "PRUEBA AHORA",
    min: "Min",
    sec: "Seg",
    now: "Ahora",
    goal: "Objetivo",
    flexibility: "Flexibilidad",
    earning_power: "Potencial de Ganancias",
    limited: "Limitado",
    high: "Alto",
    basic: "Básico",
    disclaimer: "Esto no es una garantía o promesa de resultados.",
    trial_offer: "Prueba <tag>FreeLanz 7 días por $1</tag>, y podrás:",
    // trial_offer: "APrueba <tag>Freelanz 4 Weeks</tag> y podrás:",
    benefits: {
      ai_tools:
        "Domina las herramientas de IA que pueden aumentar tus ingresos",
      additional_sources: "Descubre fuentes de ingresos adicionales",
      skills:
        "Adquiere habilidades de un Profesional Freelance y comienza a ganar",
      beginner_lessons: "Acceso a lecciones amigables para principiantes",
      guidance: "Guía para competencia y éxito en freelancing",
    },
    trial: "Prueba de 7 Días",
    // trial: "PLAN DE 4 SEMANAS",
    payment_methods: "Tarjeta de Crédito <tag>/</tag> Débito",
    guaranteed_checkout: "Pago <tag>Seguro</tag> Garantizado",
    what_you_get: "Lo Que Obtienes",
    income_know_how: "Conocimientos sobre ingresos freelance",
    lessons: "Lecciones informativas, fáciles y divertidas",
    personal_coach:
      "Chat 24/7 con tu entrenador personal para obtener respuestas y reducir errores",
    users_love: "A los Usuarios Les Encantan Nuestros Planes",
    user_reviews: {
      review_1:
        "Valoro sinceramente las lecciones que proporcionan sobre varios temas. Estoy decidido a sobresalir en esta área y he obtenido información valiosa. Ha sido una experiencia gratificante y he absorbido una gran cantidad de conocimiento.",
      review_2:
        "Debo reconocer que este curso está entre los mejores que he realizado. Ofrece ideas prácticas en el ámbito del marketing digital.",
      review_3:
        "Estos cursos han sido excepcionalmente beneficiosos. Nunca he encontrado una aplicación que brinde información tan completa como Coursiv. Lo notable es que constantemente estoy aprendiendo nuevas estrategias y tácticas para promocionarme en línea.",
    },
    career_titles: {
      digital_marketing: "Mercadotecnia Digital",
      content_writer: "Escritora de contenido",
      graphic_designer: "Diseñador Gráfico",
    },
    career_info: {
      digital_marketing: "$100,000 por año",
      content_writer: "$42,000 por año",
      graphic_designer: "$90,000 por año",
    },
    no_degree: "No es necesario ser un profesional",
    no_university_degree: "No se necesita título universitario",
    work_at_your_pace: "Trabaja a tu propio ritmo y en tus propios términos",
    people_often_ask: "La gente pregunta a menudo",
    faqs: {
      career_freedom_plan:
        "¿De qué trata el Plan de Libertad Profesional y cómo puedo comenzar?",
      commitment_concerns:
        "Estoy preocupado por comprometerme al freelancing y luego rendirme a mitad de camino.",
      technical_skills:
        "¿Es posible aprender freelancing sin habilidades técnicas especializadas?",
    },
    faq_answers: {
      career_freedom_plan:
        "FreeLanz ofrece una oportunidad para que cualquier persona se adentre en el freelancing proporcionando materiales de aprendizaje accesibles. El Plan de Libertad Profesional se centra en enseñar habilidades freelance esenciales en un formato fácil de usar y gamificado, abordando conceptos potencialmente complejos de manera comprensible.",
      commitment_concerns:
        "Entendemos tus preocupaciones, por lo que FreeLanz asegura una experiencia amigable para principiantes. Nuestro mentor de IA está disponible para proporcionar orientación a lo largo de tu viaje, requiriendo un mínimo esfuerzo de tu parte.",
      technical_skills:
        "¡Absolutamente! Nuestros recursos de aprendizaje están diseñados para simplificar los temas técnicos, haciéndolos accesibles para todos. Aunque tener algún conocimiento técnico puede ser beneficioso, no es un requisito previo para el éxito en el freelancing.",
    },
    money_back_guarantee: "Garantía de Reembolso del 100%",
    guarantee_message:
      "Creemos que nuestro plan puede funcionar para ti y obtendrás resultados en 4 semanas. Incluso estamos dispuestos a devolverte el dinero si no ves resultados, pero esto depende principalmente de ti. Por favor, revisa nuestra <tag>Política de Reembolsos</tag> para entender todos los requisitos.",
  },
};
